<template>
    <div v-if="date !== null">
        <div class="page-header">
            <h1>
                Statistics&nbsp;

                <small>
                    {{date | moment("MMMM \'YY")}}
                </small>

                <div class="pull-right">
                    <date-picker v-model="date" :config="{format: 'MMMM YYYY'}"></date-picker>
                </div>

                <div class="pull-right">
                    <print></print>&nbsp;
                </div>
            </h1>

            <br />

            <loader v-if="!hasLoaded"></loader>

            <template v-else>
                <div class="row">
                    <div class="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-12">
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>Personankomster</td>
                                    <td class="text-right">
                                        {{guests}} personankomster
                                    </td>
                                </tr>

                                <tr>
                                    <td>Gæstenætter</td>
                                    <td class="text-right">
                                        {{guestNights}} gæstenætter
                                    </td>
                                </tr>

                                <tr>
                                    <td>Værelsesnætter</td>
                                    <td class="text-right">
                                        {{roomNights}} værelsesnætter
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import Room from '@/components/calendar/Room'
    import Loader from '@/components/layout/Loader'
    import Print from '@/components/layout/Print'

    const moment = require('moment')

    import DatePicker from 'vue-bootstrap-datetimepicker'

    const RoomService = require('@/services/rooms/RoomService')
    const ReservationService = require('@/services/reservations/ReservationService')
    const TypeService = require('@/services/reservations/TypeService')

    export default {
        data() {
            return {
                hasLoaded: false,
                date: null,
                guests: 0,
                guestNights: 0,
                roomNights: 0
            }
        },

        watch: {
            date() {
                this.load()
            }
        },

        mounted() {
            this.setDefaultDate()
        },

        methods: {
            setDefaultDate() {
                this.date = moment()
            },

            load() {
                this.hasLoaded = false

                const options = {
                    includes: ['room', 'type'],

                    filter_groups: [
                        {
                            filters: [
                                {
                                    key: 'arrivalBelongsToMonth',
                                    value: this.date.format('YYYY-MM'),
                                    operator: 'ct'
                                }
                            ]
                        }
                    ]
                }

                ReservationService.findAll(options, (response) => {
                    const data = response.data

                    const startOfMonth = moment(this.date).startOf('month')
                    const endOfMonth = moment(this.date).endOf('month')

                    data.rows.forEach((reservation) => {
                        let arrival = new moment(reservation.arrival.date).startOf('day')
                        let departure = new moment(reservation.departure.date).startOf('day')

                        if (arrival < startOfMonth) {
                            arrival = startOfMonth
                        }

                        if (departure > endOfMonth) {
                            departure = endOfMonth
                        }

                        this.roomNights += departure.diff(arrival, 'days')
                        this.guests += reservation.guests
                        this.guestNights += reservation.guests * departure.diff(arrival, 'days')
                    })

                    this.hasLoaded = true
                })
            }
        },

        components: {
            Loader,
            Room,
            DatePicker,
            Print
        }
    }
</script>


// WEBPACK FOOTER //
// Statistics.vue?67d1f898